import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetWatchReviewStatsResponse } from './get-watch-review-stats-response';
import { getWatchReviewStatsResponseSchema } from './get-watch-review-stats-response';

export async function getWatchReviewStatsApi(): Promise<
  IValidatedResponse<IGetWatchReviewStatsResponse>
> {
  return getRequest<IGetWatchReviewStatsResponse>({
    path: '/progress/reviews/watch',
    schema: getWatchReviewStatsResponseSchema,
  });
}
